import { render, staticRenderFns } from "./complains-table.vue?vue&type=template&id=1b588ef6&scoped=true&"
import script from "./complains-table.vue?vue&type=script&lang=js&"
export * from "./complains-table.vue?vue&type=script&lang=js&"
import style0 from "./complains-table.vue?vue&type=style&index=0&id=1b588ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b588ef6",
  null
  
)

export default component.exports